import { fromBase64 } from '@easterngraphics/wcf/modules/utils/arraybuffer';
export function getBlob(content: string | Blob | ArrayBuffer | Uint8Array<ArrayBufferLike>): Blob {
    if (content instanceof Blob) {
        return content;
    } else if (content instanceof ArrayBuffer) {
        return new Blob([content]);
    } else if (content instanceof Uint8Array) {
        const bufferLike = content.buffer;
        if (bufferLike instanceof ArrayBuffer) {
            // Safe: content might be a slice, so we copy the relevant portion
            const safeBuffer = bufferLike.slice(content.byteOffset, content.byteOffset + content.byteLength);
            return new Blob([safeBuffer]);
        } else {
            // It's a SharedArrayBuffer — must copy to a new ArrayBuffer
            const copied = new Uint8Array(content.byteLength);
            copied.set(content);
            return new Blob([copied.buffer]); // now it's a safe ArrayBuffer
        }
    }

    return new Blob([fromBase64(content)]);
}

export function getArrayBuffer(content: Uint8Array<ArrayBufferLike> | ArrayBufferLike): ArrayBuffer {
    if (content instanceof Uint8Array) {
        const bufferLike = content.buffer;
        if (bufferLike instanceof ArrayBuffer) {
            // Safe: content might be a slice, so we copy the relevant portion
            const safeBuffer = bufferLike.slice(content.byteOffset, content.byteOffset + content.byteLength);
            return safeBuffer;
        } else {
            // It's a SharedArrayBuffer — must copy to a new ArrayBuffer
            const copied = new Uint8Array(content.byteLength);
            copied.set(content);
            return copied.buffer; // now it's a safe ArrayBuffer
        }
    }

    // Handle raw ArrayBufferLike (ArrayBuffer or SharedArrayBuffer)
    if (content instanceof ArrayBuffer) {
        return content.slice(0); // Return a copy of the ArrayBuffer
    }

    // If it's a SharedArrayBuffer, copy it to a new ArrayBuffer
    const shared = new Uint8Array(content); // Creates view on SharedArrayBuffer
    const copy = new Uint8Array(shared.length);
    copy.set(shared);
    return copy.buffer;
}
